<div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <!-- <div fxFlex="5%">
            <sui-checkbox> </sui-checkbox>
          </div> -->
      <div fxFlex="30">Action</div>
      <div fxFlex="40">Description</div>
      <div fxFlex></div>
    </div>

    <app-file-upload-setting-row
      [file]="file"
      *ngFor="let file of files"
      (editUnit)="editConcurrentUploadLimit($event)"
      (onView)="viewConcurrentUploadLimit($event)"
    ></app-file-upload-setting-row>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
